import { CHART_HEAD, CHART_UNDER_HEAD } from '@/components/charts/chart-header-layout'
import DataTableSkeleton from '@/components/ui/DataTableSkeleton'
import Skeleton from '@/components/ui/Skeleton'
import { cn } from '@/lib/utils'

/*
 * Market · Indices before its first response: the LOADED board, block for
 * block — the chart band on the page, then the indices table in DataTable's
 * own panel (`DataTableSkeleton`, which reads its head band and `md` row).
 *
 * The band's head is `ChartHeader`'s own grid, by name (`CHART_HEAD`, a plain
 * module, since a pending file must not import a component module), so the
 * two switch at the same container width: the 28px name over the 40px figure
 * row, beside the Line/Candles track and the 40px chart button over the six
 * 48px boxed periods (38 tall with their hairlines; `h-9` here). The chart is
 * the `market` look's 212px (`h-53`), 24 under the head.
 *
 * Bars only, no words, so nothing here can be mistaken for the loaded
 * content. The page's own TitleRow is the exception, and ScreenLayout draws
 * it (see IndicesScreen).
 */

const INDEX_ROWS = 4

function ChartBandSkeleton() {
  return (
    <div className="flex min-w-0 flex-col">
      <div className={CHART_HEAD.root}>
        <div className={CHART_HEAD.grid}>
          <div className={CHART_HEAD.info}>
            <div className="flex h-7 items-center">
              <Skeleton className="h-4 w-32 rounded-xs" />
            </div>
            <div className="flex h-10 items-center gap-3">
              <Skeleton className="h-6 w-28 rounded-sm" />
              <Skeleton className="h-4 w-20 rounded-xs" />
            </div>
          </div>
          <div className={CHART_HEAD.actions}>
            <div className={cn(CHART_HEAD.controls, 'justify-between')}>
              <Skeleton className="h-10 w-36" />
              <Skeleton className="size-10" />
            </div>
            <Skeleton className="h-9 w-74" />
          </div>
        </div>
      </div>
      <Skeleton className={cn(CHART_UNDER_HEAD, 'h-53 w-full')} />
    </div>
  )
}

export function IndicesBoardSkeleton() {
  return (
    <>
      <ChartBandSkeleton />
      <DataTableSkeleton rows={INDEX_ROWS} columns={5} />
    </>
  )
}
